import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Route } from 'app/models/route.model';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../users/user.service';
// import { Route } from 'app/models/route.model';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  apiUrl: string = `${environment.apiUrl}route`;
  constructor(private httpClient: HttpClient, private userService: UserService) { }

  public async getRoutes(domainId: number){
    return await this.httpClient.get<Route[]>(this.apiUrl +  `?domainId=${domainId}`).toPromise();
  }

  public async getRoute(id: number){
    return await this.httpClient.get<Route>(this.apiUrl+'/'+id).toPromise();
  }

  public saveRoute(route: Route){
    console.log('save route', route);
    try {
      if(route.id){
        console.log('Actualiando ruta...');
        return this.httpClient.put<Route>(this.apiUrl, route).pipe(
          catchError(this.handleError)
        );
      }else{
        console.log('Guardando nueva ruta...');
        return this.httpClient.post<Route>(this.apiUrl, route).pipe(
          catchError(this.handleError)
        );
      }
    } catch (error) {
      throw error;
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}